/**
 * <norvegr-modal data-modal-id="size-guide">
 *
 * Lightweight modal for guides (size / weight). Open with:
 *   document.dispatchEvent(new CustomEvent('norvegr:open-modal', { detail: { id: 'size-guide' } }));
 * or any element with [data-norvegr-modal-open="size-guide"].
 */
if (!customElements.get('norvegr-modal')) {
  class NorvegrModal extends HTMLElement {
    constructor() {
      super();
      this.lastTrigger = null;
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      // Move to <body> so the modal sits above any drawer / stacking context.
      if (this.parentElement !== document.body) {
        const modalId = this.dataset.modalId;
        document.body.querySelectorAll(':scope > norvegr-modal').forEach((el) => {
          if (el !== this && el.dataset.modalId === modalId) el.remove();
        });
        document.body.appendChild(this);
        return;
      }

      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      this.querySelectorAll('[data-norvegr-modal-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open(trigger) {
      if (this.isOpen) return;
      this.lastTrigger = trigger || document.activeElement;
      this.hidden = false;
      // Next frame so the opacity / scale transition runs.
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.addEventListener('keydown', this.onKeyDown, true);

      const dialog = this.querySelector('[role="dialog"]');
      if (dialog) dialog.focus({ preventScroll: true });
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKeyDown, true);
      // Stay in the DOM until the slide-out / fade has finished.
      setTimeout(() => {
        if (!this.isOpen) this.hidden = true;
      }, 360);
      if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
        this.lastTrigger.focus({ preventScroll: true });
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        // Close the modal only; keep any drawer underneath open.
        event.stopPropagation();
        this.close();
      }
    }
  }

  customElements.define('norvegr-modal', NorvegrModal);

  const openById = (id, trigger) => {
    const modal = Array.from(document.querySelectorAll('norvegr-modal')).find((el) => el.dataset.modalId === id);
    if (modal) modal.open(trigger);
  };

  document.addEventListener('norvegr:open-modal', (event) => {
    const id = event.detail && event.detail.id;
    if (id) openById(id, event.detail.trigger);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-norvegr-modal-open]');
    if (!trigger) return;
    event.preventDefault();
    document.dispatchEvent(
      new CustomEvent('norvegr:open-modal', {
        detail: { id: trigger.dataset.norvegrModalOpen, trigger },
      })
    );
  });
}
